export const useHandlers = () => {
  return {
    data: {},
    state: {},
    handlers: {},
  }
}
